export const RESULT_TRACE_GET_REQUEST = 'RESULT_TRACE_GET_REQUEST';
export const RESULT_TRACE_GET_SUCCESS = 'RESULT_TRACE_GET_SUCCESS';
export const RESULT_TRACE_GET_ERROR = 'RESULT_TRACE_GET_ERROR';
export const RESULT_TRACE_GET_BY_KEY_REQUEST = 'RESULT_TRACE_GET_BY_KEY_REQUEST';
export const RESULT_TRACE_GET_BY_KEY_SUCCESS = 'RESULT_TRACE_GET_BY_KEY_SUCCESS';
export const RESULT_TRACE_GET_BY_KEY_ERROR = 'RESULT_TRACE_GET_BY_KEY_ERROR';
export const RESULT_TRACE_ADD_REQUEST = 'RESULT_TRACE_ADD_REQUEST';
export const RESULT_TRACE_ADD_SUCCESS = 'RESULT_TRACE_ADD_SUCCESS';
export const RESULT_TRACE_ADD_ERROR = 'RESULT_TRACE_ADD_ERROR';
export const RESULT_TRACE_EDIT_REQUEST = 'RESULT_TRACE_EDIT_REQUEST';
export const RESULT_TRACE_EDIT_SUCCESS = 'RESULT_TRACE_EDIT_SUCCESS';
export const RESULT_TRACE_EDIT_ERROR = 'RESULT_TRACE_EDIT_ERROR';
export const RESULT_TRACE_DELETE_REQUEST = 'RESULT_TRACE_DELETE_REQUEST';
export const RESULT_TRACE_DELETE_SUCCESS = 'RESULT_TRACE_DELETE_SUCCESS';
export const RESULT_TRACE_DELETE_ERROR = 'RESULT_TRACE_DELETE_ERROR';
